/* Configuration Templates management page - ET12_CONFIGURATION_MONITORING_SPEC.md section 8
   (device SDK repo root). Deliberately kept as a plain 3-field form (name/description/
   ignore_patterns textarea) + a file upload, matching the spec's own "keep this UI simple, do
   not build a complex rule editor in V1" instruction. */
import { Datagrid, DateField, List, TextField, TextInput } from 'react-admin';
import { Create, Edit, SimpleForm, required } from 'react-admin';
import { FileInput, FileField } from 'react-admin';

const configTemplateFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
];

export const ConfigTemplateList = () => (
    <List perPage={50} sort={{ field: 'name', order: 'ASC' }} filters={configTemplateFilters}>
        <Datagrid rowClick="edit">
            <TextField source="name" />
            <TextField source="description" />
            <TextField label="MD5" source="base_backup_md5" />
            <DateField label="Base Backup Uploaded" source="base_backup_uploaded_at" showTime />
            <DateField label="Updated" source="updated_at" showTime />
        </Datagrid>
    </List>
);

function ConfigTemplateForm({ isCreate }) {
    return (
        <SimpleForm>
            <TextInput source="name" validate={required()} fullWidth />
            <TextInput source="description" fullWidth />
            <TextInput
                source="ignore_patterns"
                label="Ignore Patterns (one per line - plain path, path.subtree, or path.wild*)"
                multiline
                rows={8}
                fullWidth
            />
            <FileInput source="base_backup_file" label={isCreate ? "Base Configuration (config.tar.gz)" : "Replace Base Configuration (optional)"}
                validate={isCreate ? required() : undefined}>
                <FileField source="base_backup_file" title="title" />
            </FileInput>
        </SimpleForm>
    );
}

export const ConfigTemplateCreate = () => (
    <Create>
        <ConfigTemplateForm isCreate={true} />
    </Create>
);

export const ConfigTemplateEdit = () => (
    <Edit>
        <ConfigTemplateForm isCreate={false} />
    </Edit>
);
